import React from 'react';
import AccountSimplifiedDTO from 'features/accounts/dtos/AccountSimplifiedDTO';
import RoundButton from 'features/shared/components/buttons/RoundButton';
import CustomerSimplifiedDTO from 'features/customer/dtos/CustomerSimplifiedDTO';
import { useTranslation } from 'react-i18next';

interface Props {
  account: AccountSimplifiedDTO;
  onDeleteClick?: (account: AccountSimplifiedDTO) => void;
  onDetailClick?: (account: AccountSimplifiedDTO) => void;
}

const AccountSimplified = ({ account, onDeleteClick, onDetailClick }: Props) => {
  // translations
  const tRoles = useTranslation("customer\\enums\\customerRole").t;
  const tLabels = useTranslation("accounts\\accounts").t;

  // sub-renders
  const renderRoles = (): string => {
    return account.roles && account.roles?.length > 0
      ? account.roles?.map((str) => tRoles(str)).join(", ")
      : "-";
  };

  const renderRestrictions = () => {
    if (account.hasRestrictions) {
      return (
        <span className="badge badge-pill badge-danger small font-weight-normal">{tLabels("accountSimplified.withRestrictions")}</span>
      );
    } else {
      return (
      <span className="badge badge-pill badge-success small font-weight-normal">{tLabels("accountSimplified.withoutRestrictions")}</span>
      );
    }
  }

  const renderDetailButton = () => {
    if (onDetailClick) {
      return <RoundButton onClickHandler={() => onDetailClick(account)} className="mr-1" />;
    } else {
      return <RoundButton asLink to={`accounts/${account.accountId}`} className="mr-1" />;
    }
  }

  // render
  return (
    <div className="row no-gutters align-items-center">
      <div className="col">
        <div className="row no-gutters align-items-center">
          <div className="col-sm-5">
            {account.email}
          </div>
          <div className="col-auto col-sm-4 text-muted pr-2 pr-sm-0 px-sm-4 text-truncate">
            {renderRoles()}
          </div>
          <div className="col-auto col-sm-3">
            {renderRestrictions()}
          </div>
        </div>
      </div>
      <div className="col-auto pl-2">
        {renderDetailButton()}
        {onDeleteClick !== undefined &&
          <RoundButton icon="trash" onClickHandler={() => onDeleteClick(account)} />
        }
      </div>
    </div>
  )
}

export default AccountSimplified;
